import Vue from 'vue'
import App from '@/App.vue'
import qs from "qs"

Vue.prototype.$url = {
	getParams() {
		let q = window.location.search;
		if (!!q && q.length > 1) {
			q = q.substring(1);
			return qs.parse(q) || {};
		}
		return {};
	}
}

Vue.prototype.$colors = [
	"#ea7ccc",
	"#fc8452",
	"#9a60b4",
	"#5470c6",
	"#ee6666",
	"#91cc75",
	"#fac858",
	"#73c0de",
	"#3ba272",
	"#c12e34",
	"#e6b600",
	"#0098d9"];

new Vue({
	render: h => h(App),
}).$mount('#app')
